import { render, staticRenderFns } from "./RecordsView.vue?vue&type=template&id=bf57399a&scoped=true"
import script from "./RecordsView.vue?vue&type=script&lang=js"
export * from "./RecordsView.vue?vue&type=script&lang=js"
import style0 from "./RecordsView.vue?vue&type=style&index=0&id=bf57399a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf57399a",
  null
  
)

export default component.exports